<template>
    <div id="allOrders">
        <Breadcrumb></Breadcrumb>
        <div class="form-body">
            <el-form :model="form" ref="form" class="form">
                <div class="form-border-div" style="padding-bottom: 10px">
                    <el-form-item label="商家账号:" class="normal-input">
                        <el-input size="small" v-model="form.account" placeholder="请输入商家账号"></el-input>
                    </el-form-item>
                    <el-form-item label="订单状态:">
                        <el-select clearable  size="small" v-model="form.status" @change="getList">
                            <el-option label="全部" value="all"></el-option>
                            <el-option v-for="item in stateList" :label="item.dictLabel" :value="item.dictValue"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="平台订单号:" class="normal-input">
                        <el-input size="small" v-model="form.eAppNo" placeholder="请输入平台订单号，多个平台订单号用英文逗号隔开"></el-input>
                    </el-form-item>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="XXX订单号:" style="width: 100%;display: flex;">
                                <el-input size="small" v-model="form.sAppNo" placeholder="请输入XXX订单号，多个XXX订单号用英文逗号隔开"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6" style="margin-left: 15px">
                            <el-form-item>
                                <el-button size="small" @click="resetForm">重置</el-button>
                                <el-button size="small" type="primary" @click="search">搜索</el-button>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>
                <div style="margin: 10px 0">
                    <el-form-item label="排序方式:">
                        <el-radio-group v-model="form.sortord" @change="sortordChange" class="hide_input sort-group" >
                            <!--<el-radio label="0">按产品SKU<i class="el-icon-caret-top" @click="turnWay"></i></el-radio>-->
                            <el-radio label="ORDER_TIME">按下单时间<i class="el-icon-caret-bottom" @click="turnWay"></i></el-radio>
                            <el-radio label="REQ_DELI_TIME">按剩余发货时间<i class="el-icon-caret-bottom" @click="turnWay"></i></el-radio>
                            <el-radio label="ACT_PAY">按订单金额<i class="el-icon-caret-bottom" @click="turnWay"></i></el-radio>
                        </el-radio-group>
                    </el-form-item>
                </div>
            </el-form>
        </div>

        <div class="div-plan">
            <div class="btn_1">
                <el-dropdown size="small" style="padding-left: 10px" @command="exportOrder">
                    <el-button size="small" type="primary">
                        导出订单<i class="el-icon-arrow-down el-icon--right"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown" >
                        <el-dropdown-item command="0">导出选中订单</el-dropdown-item>
                        <el-dropdown-item command="1">导出全部订单</el-dropdown-item>
                        <!--                        <el-dropdown-item command="2">按模板导出</el-dropdown-item>-->
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
            <pagination
                    v-show="total>0"
                    :total="total"
                    :page.sync="form.pageNum"
                    :limit.sync="form.pageSize"
                    @pagination="getList"
            />
        </div>
        <div class="fh-tab">
            <el-table :data="orderData" :span-method="arraySpanMethod" default-expand-all @selection-change="tableSelectionChange">
                <el-table-column type="selection" width="55" align="center"></el-table-column>
                <el-table-column label="商品信息" header-align="center" align="left" width="160" >
                    <template scope="props">
                        <a href="javascript:void(0)" @click="showDetail(props.row,'3')" style="text-decoration: none">
                            <span style="color: #337ab7">{{props.row.trackNo}}</span>
                        </a>
                        <!--                        <el-tooltip :content="props.row.orderRemark" placement="bottom" effect="light">-->
                        <!--                            <el-tag class="tag-bz" v-if="props.row.orderRemark">拣</el-tag>-->
                        <!--                        </el-tooltip>-->
                    </template>
                </el-table-column>
                <el-table-column type="expand">
                    <template scope="props">
                        <table class="fh-inner-tab">
                            <tr>
                                <td style="width: 260px;">
                                    <div style="display: flex;margin: 10px 0 0 10px" v-for="item in props.row.orderSku">
                                        <el-popover placement="right" width="300" trigger="hover" :disabled="item.picAddr == null">
                                            <div style="text-align: right;background-color: rgba(239,239,239,1);height: 25px;line-height: 25px">
                                                <span style="padding-right: 20px">添加来源</span>
                                            </div>
                                            <img  class="img-big" :src="item.picAddr" style="width: 300px;height: 300px"/>
                                            <img v-if="item.picAddr != null" slot="reference" class="img-small" :src="item.picAddr" style="width: 70px;height: 70px;padding: 1px;border: 1px solid #EBEEF5"/>
                                            <img v-else slot="reference" class="img-small" src="../../../assets/images/kong.png" style="width: 70px;height: 70px;padding: 1px;border: 1px solid #EBEEF5"/>
                                            <br/>
                                            <el-dropdown slot="reference" size="mini" class="orderList-el-dropdown" trigger="click" >
                                                  <span class="el-dropdown-link" v-show="!props.row.manualFlag">
                                                    来源<i class="el-icon-caret-bottom el-icon--right"></i>
                                                  </span>
                                                <el-dropdown-menu slot="dropdown">
                                                    <el-dropdown-item disabled >平台产品</el-dropdown-item>
                                                    <el-dropdown-item class="product-source" divided>来源1: 1688</el-dropdown-item>
                                                </el-dropdown-menu>
                                            </el-dropdown>
                                        </el-popover>
                                        <div style="font-size: 13px;text-align: left">
                                            <el-row class="order-sku" style="display: flex;align-items: center"><a href="javascript:void(0)" style="text-decoration: none">{{item.skuName}}</a><span>×</span><div class="p-num">{{item.num}}</div></el-row>
                                            <el-row>{{props.row.coinType}} {{item.price}}</el-row>
                                        </div>
                                    </div>

                                </td>
                                <td style="width: 115px"> <span>{{props.row.proPri}}</span></td>
                                <td style="width: 240px;text-align: left"> <span>{{props.row.cons}} 「{{props.row.country}}」</span></td>
                                <td style="width: 140px;text-align: left">
                                    <span style="color: #409eff">{{props.row.sAppNo}}</span><br/>
                                    <el-tooltip :content="props.row.orderRemark" placement="bottom" effect="light">
                                        <el-tag class="tag-bz" v-if="props.row.orderRemark">备</el-tag>
                                    </el-tooltip>
                                </td>
                                <td style="width: 180px">
                                    <span>下单:{{props.row.orderTime}}</span><br/>
                                    <span>付款:{{props.row.payTime}}</span>
                                </td>
                                <td style="width: 120px;font-size: 12px">
                                    <span>{{props.row.expreMode}}</span>
                                </td>
                                <td style="width: 100px;font-size: 12px">
                                    <span>{{props.row.stateName}}</span>
                                </td>
                                <td class="inner-tab-btn">
                                    <div><el-button  type="text" size="mini" @click="showDetail(props.row,'1')">详情</el-button></div>
                                </td>
                            </tr>
                        </table>
                    </template>
                </el-table-column>

                <el-table-column label="订单金额" align="center" width="120"></el-table-column>
                <el-table-column label="收件人【国家/地区】" align="center" width="240"></el-table-column>
                <el-table-column label="订单号" align="center" width="140"></el-table-column>
                <el-table-column label="时间" align="center" width="180"></el-table-column>
                <el-table-column label="物流方式" align="right" header-align="center" width="120">
                    <template slot-scope="scope">
                        <span v-if="!scope.row.manualFlag">「 {{scope.row.eName}} : {{scope.row.shopName}} 」</span>
                        <span v-else>「 手工订单 」</span>
                    </template>
                </el-table-column>
                <el-table-column label="状态" align="center" width="100"></el-table-column>
                <el-table-column label="操作"  align="center" ></el-table-column>
            </el-table>
            <pagination
                    v-show="total>0"
                    :total="total"
                    :page.sync="form.pageNum"
                    :limit.sync="form.pageSize"
                    @pagination="getList"
            />
        </div>
        <orderDetail :dataMap="detailProps" ref="orderDetail" class="order-detail"></orderDetail>
        <el-dialog :close-on-click-modal="false"   title="审核" :visible.sync="processOrderVisible" width="20%">
            <div style="margin: 20px">
                <el-radio v-model="handleNum" label="1">启动采购流程</el-radio>
                <el-radio v-model="handleNum" label="2">移入待交运</el-radio>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button size="small" @click="processOrderVisible = false">取 消</el-button>
                <el-button size="small" type="primary" @click="choseHandleNum">确 定</el-button>
            </span>
        </el-dialog>
        <order-note :noteData="noteData" ref="orderNote"></order-note>
        <export-dialog :exportParam="exportParam"></export-dialog>
    </div>
</template>

<script type="text/ecmascript-6">
    import {getOrderList,updateOrderState} from '@/api/order/all'
    import orderDetail from '@/components/order/orderDetail'
    import Breadcrumb from '@/components/common/Breadcrumb'
    import {mapGetters} from 'vuex'
    import orderNote from '@/components/order/orderNote'
    import exportDialog from '@/components/order/exportDialog'
    export default {
        name: "allOrders",
        components:{
            orderDetail,Breadcrumb,orderNote,exportDialog
        },
        data() {
            return {
                total:0,
                blackListVisible:false,
                processOrderVisible:false,//处理订单提示窗口
                currentPage: 1,
                iconType:'el-icon-arrow-down el-icon--right',
                form: {
                    pageNum: 1,
                    pageSize: 10,
                    status:'all',//订单状态
                    sortord:'ORDER_TIME',//排序字段
                    byAsc:'desc',//升序或者降序
                    eAppNo:'',//平台订单号
                    sAppNo:'',//xx订单号
                    account:undefined,//商家账户
                    manualFlag:'0',
                },
                showMoreItem:false,
                allCountries:{},
                countries:[],
                platList:[],
                accList:[],
                rules:{cause:[{required: true, message: '请选择原因', trigger: 'blur'}]},
                orderData:[],
                multipleSelection:[],//表格中勾选的数据
                detailProps:{
                    visible:false,
                    title:''
                },
                noteData:{
                    visible:false,
                    appId:null,
                    source:null
                },
                kongImgSrc:'../../../assets/images/kong.png',
                handleNum:null,
                currentOrder:null,
                exportParam:{
                    visible:false,
                    type:null,//0：导出勾选，1：导出全部
                    orderIds:[],//选中要导出的订单id（为空则导出全部订单）
                }
            }
        },
        computed:{
            ...mapGetters(['orderStatus','platCode',]),
            //订单状态列表
            stateList(){
                return this.orderStatus;
            },
            userPlatList(){
                return this.platCode;
            },
            userShopList(){
                return this.shopList;
            }
        },
        created() {
            this.loadInitData();
            this.getList();
        },
        methods: {
            //获取订单列表数据
            getList(){
                getOrderList(this.form).then(res =>{
                    this.total = res.total;
                    this.orderData = res.rows;
                })
            },
            async loadInitData(){
                try{
                    let platDict = JSON.parse(sessionStorage.getItem("platCode"));
                    let platCode = JSON.parse(JSON.stringify(this.$store.state.product.amazon.shopList));
                    platCode.map(code =>{
                        platDict.forEach(dict =>{
                            if(code.platNo == dict.dictValue){
                                code.shopName += `  (` + dict.dictLabel + `)`;
                            }
                        })
                    });
                    //获取所有平台代码
                    let data = [];
                    data.push({platNo:'all', platName:'全部', shopList:platCode})
                    platDict.forEach(dict => {
                        let map ={};
                        map.platNo = dict.dictValue;
                        map.platName = dict.dictLabel;
                        map.shopList = [];
                        platCode.forEach(code =>{
                            if(dict.dictValue == code.platNo){
                                map.shopList.push(code)
                            }
                        });
                        data.push(map);
                    });
                    this.platList = data.filter(item => {return item.shopList.length > 0});
                    this.accList = platCode;
                }catch (e) {
                    console.log(e)
                }
            },
            search: function() {
                this.getList();
            },
            resetForm:function(){
                this.form.eAppNo=[];
                this.form.sAppNo=[];
                this.form.eSku=[];
                this.form.sSku=[];
                this.form.cons=[];
            },
            sortordChange:function(val){
                /*$(".sort-up-down .el-radio").each((item) => {
                    console.log(item);
                });*/
                this.form.sortord =val;
                this.getList();
            },
            turnWay:function(e){
                var classVal =  e.target.className;
                if(classVal == 'el-icon-caret-top'){
                    e.target.setAttribute('class','el-icon-caret-bottom');
                    this.form.byAsc = 'desc';
                }else{
                    e.target.setAttribute('class','el-icon-caret-top');
                    this.form.byAsc = 'asc';
                }
                this.getList();
            },

            choseHandleNum(){
                var that = this;
                this.processOrderVisible = false;
                if(this.handleNum == 1){//启动采购流程
                    console.log(this.currentOrder);
                }else if(this.handleNum == 2){ //移入带交运
                    let param = {'appId':this.currentOrder.appId,'state':'5'};

                    updateOrderState(param).then(res => {
                        if(res.code == '200'){
                            this.$message({
                                message: '订单移入待交运成功！',
                                type: 'success',
                                center: true,
                            });
                            that.getList();
                        }

                    });
                }
            },
            addNote(row){
                this.noteData.visible = true;
                this.noteData.appId = row.appId;
                this.noteData.source = 1;//0表示会点击弹框中的备注按钮，1表示点击列表中的备注按钮
                this.$refs.orderNote.loadNote(row.appId);
            },
            showDetail:function(row,activeTab){
                let params = {
                    appId:row.appId,
                    status:row.sOrderStatus
                }
                let platName = row.manualFlag?'手工订单':row.eName;
                this.detailProps.visible=true;
                this.detailProps.title = '包裹 「 '+ row.trackNo + ' 」详情 - 来源于「'+platName+'」';
                this.detailProps.activeTab = activeTab;
                //加载订单详情数据
                this.$refs.orderDetail.loadOrderDetail(params);
            },
            handleSelectionChange: function(val) {
                var ids = [];
                val.forEach((item) => {
                    if (ids.indexOf(item.id) == -1) {
                        ids.push(item.id);
                    }
                });
                this.$message({
                    message: '选择提示:已选择' + ids.length + '条',
                    center: true,
                    offset: 200
                });

            },
            //合并列
            arraySpanMethod: function({row,column,rowIndex,columnIndex}) {
                if (columnIndex === 1) {
                    return [1, 2];
                }else if(columnIndex === 2 ){
                    return [0, 0];
                }

                if(columnIndex === 7){
                    return [1, 3];
                }else if(columnIndex === 8 ||columnIndex === 9){
                    return [0,0];
                }
            },

            loadAllCountry(){
                let that = this;
                $.ajax({
                    url:process.env.BASE_URL + 'country.json',
                    method:'get',
                    success:function (res) {
                        let all = [];
                        // res.map.forEach((value,key) =>{
                        //     all.concat(value);
                        // });
                        for(let key in res.map){
                            all = all.concat(res.map[key])
                        }
                        res.map['0'] = all;
                        that.allCountries = JSON.parse(JSON.stringify(res));
                        that.countries = that.allCountries.map['0'];
                    }
                })
            },
            tableSelectionChange(val){
                this.multipleSelection = val;
            },
            //导出订单
            exportOrder(val){
                //val =0 时 导出选中订单  1 导出全部订单 2 按模板导出
                if(val == 0){
                    if(!this.multipleSelection.length > 0){
                        this.$message.warning("请至少选择一个订单！");
                        return false;
                    }
                    this.exportParam.type = 0;
                    this.exportParam.visible = true;
                    let ids = [];
                    this.multipleSelection.forEach(item => {
                        ids.push(item.appId);
                    });
                    this.exportParam.orderIds = ids;
                }else if(val == 1){//导出全部订单
                    this.exportParam.type = 1;
                    this.exportParam.queryForm = this.form;
                    this.exportParam.visible = true;

                }else if(val == 2){

                }
            }
        },
        mounted() {

        }
    }
</script>

<style scoped>

    #allOrders{
        width: 100%;
    }
    .el-radio__label{font-size: 13px !important;}
    .orderList-el-dropdown{display: flow-root;font-size: 13px}
    .product-source{text-align: right}
    .el-dropdown-menu{margin-top: 5px !important;}

    .form .form-border-div >>>.el-form-item__content {
        width: 88%;
    }

    .div-plan {
        border: 1px solid #dcdcdc;
        border-bottom: 0px;
        width: 99.9%;
    }
    .div-plan >>>.btn_1 {
        border-bottom: 1px solid #dcdcdc;
        padding: 5px 0 15px 10px;
    }

    #allOrders >>>.el-table__body-wrapper {
        width: 90%;
        /*margin: 0 10px;*/
    }
    /*#allOrders >>>.el-table__body {*/
    /*width: 100% !important;*/
    /*}*/

</style>
